/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AttendeeReport,
    AttendeeReportFromJSON,
    AttendeeReportToJSON,
    ContactReport,
    ContactReportFromJSON,
    ContactReportToJSON,
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeToJSON,
    DateMacro,
    DateMacroFromJSON,
    DateMacroToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventRegistrationReport,
    EventRegistrationReportFromJSON,
    EventRegistrationReportToJSON,
    FeedbackRating,
    FeedbackRatingFromJSON,
    FeedbackRatingToJSON,
    Gender,
    GenderFromJSON,
    GenderToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    MembershipReport,
    MembershipReportFromJSON,
    MembershipReportToJSON,
    MembershipStatus,
    MembershipStatusFromJSON,
    MembershipStatusToJSON,
    OrderItemType,
    OrderItemTypeFromJSON,
    OrderItemTypeToJSON,
    PaymentsReport,
    PaymentsReportFromJSON,
    PaymentsReportToJSON,
    PayoutReconciliationReport,
    PayoutReconciliationReportFromJSON,
    PayoutReconciliationReportToJSON,
    ProgramEventType,
    ProgramEventTypeFromJSON,
    ProgramEventTypeToJSON,
    RegistrationReport,
    RegistrationReportFromJSON,
    RegistrationReportToJSON,
    RegistrationReportV2,
    RegistrationReportV2FromJSON,
    RegistrationReportV2ToJSON,
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusToJSON,
    SalesFinanceReport,
    SalesFinanceReportFromJSON,
    SalesFinanceReportToJSON,
    SalesFinanceReportV2,
    SalesFinanceReportV2FromJSON,
    SalesFinanceReportV2ToJSON,
    SalesSummaryReport,
    SalesSummaryReportFromJSON,
    SalesSummaryReportToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    TaxesReport,
    TaxesReportFromJSON,
    TaxesReportToJSON,
} from '../models';

export interface FindReportAttendeeReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindReportContactReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    is_subscribed?: boolean;
    has_account?: boolean;
    is_archived?: boolean;
}

export interface FindReportCsvAttendeeReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindReportCsvContactReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    is_subscribed?: boolean;
    has_account?: boolean;
    is_archived?: boolean;
}

export interface FindReportCsvEventRegistrationReportRequest {
    event_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportCsvMembershipReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
}

export interface FindReportCsvPaymentsReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportCsvPayoutReconciliationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface FindReportCsvRegistrationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    registration_status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    include_fee?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    event_type?: Array<ProgramEventType>;
}

export interface FindReportCsvRegistrationReportV2Request {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    event_id?: Array<string>;
    status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    is_fee_included?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindReportCsvSalesFinanceReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    item_type?: Array<OrderItemType>;
}

export interface FindReportCsvSalesFinanceReportV2Request {
    program_id: string;
    sort?: string;
    order?: GetManyOrder;
    skip?: number;
    limit?: number;
    currency?: CurrencyCode;
    product_id?: Array<string>;
    product_category_id?: Array<string>;
    program_id2?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportCsvSalesSummaryReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportCsvTaxesReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface FindReportEventRegistrationReportRequest {
    event_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportMembershipReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
}

export interface FindReportPaymentsReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportPayoutReconciliationReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportRegistrationReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    registration_status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    include_fee?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    event_type?: Array<ProgramEventType>;
}

export interface FindReportRegistrationReportV2Request {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    event_id?: Array<string>;
    status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    is_fee_included?: boolean;
    feedback_rating?: Array<FeedbackRating>;
}

export interface FindReportSalesFinanceReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    item_type?: Array<OrderItemType>;
}

export interface FindReportSalesFinanceReportV2Request {
    program_id: string;
    sort?: string;
    order?: GetManyOrder;
    skip?: number;
    limit?: number;
    currency?: CurrencyCode;
    product_id?: Array<string>;
    product_category_id?: Array<string>;
    program_id2?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportSalesSummaryReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportTaxesReportRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportXlsxAttendeeReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindReportXlsxContactReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    is_subscribed?: boolean;
    has_account?: boolean;
    is_archived?: boolean;
}

export interface FindReportXlsxEventRegistrationReportRequest {
    event_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportXlsxMembershipReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
}

export interface FindReportXlsxPaymentsReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportXlsxPayoutReconciliationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface FindReportXlsxRegistrationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    registration_status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    include_fee?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    event_type?: Array<ProgramEventType>;
}

export interface FindReportXlsxRegistrationReportV2Request {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    event_id?: Array<string>;
    status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    is_fee_included?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindReportXlsxSalesFinanceReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    item_type?: Array<OrderItemType>;
}

export interface FindReportXlsxSalesFinanceReportV2Request {
    program_id: string;
    sort?: string;
    order?: GetManyOrder;
    skip?: number;
    limit?: number;
    currency?: CurrencyCode;
    product_id?: Array<string>;
    product_category_id?: Array<string>;
    program_id2?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportXlsxSalesSummaryReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface FindReportXlsxTaxesReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface RequestReportCsvAttendeeReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface RequestReportCsvContactReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    is_subscribed?: boolean;
    has_account?: boolean;
    is_archived?: boolean;
}

export interface RequestReportCsvEventRegistrationReportRequest {
    event_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportCsvMembershipReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
}

export interface RequestReportCsvPaymentsReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportCsvPayoutReconciliationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface RequestReportCsvRegistrationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    registration_status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    include_fee?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    event_type?: Array<ProgramEventType>;
}

export interface RequestReportCsvRegistrationReportV2Request {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    event_id?: Array<string>;
    status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    is_fee_included?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    order?: GetManyOrder;
    sort?: string;
}

export interface RequestReportCsvSalesFinanceReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    item_type?: Array<OrderItemType>;
}

export interface RequestReportCsvSalesFinanceReportV2Request {
    program_id: string;
    sort?: string;
    order?: GetManyOrder;
    skip?: number;
    limit?: number;
    currency?: CurrencyCode;
    product_id?: Array<string>;
    product_category_id?: Array<string>;
    program_id2?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportCsvSalesSummaryReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportCsvTaxesReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface RequestReportXlsxAttendeeReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    age?: number;
    contact_id?: string;
    has_account?: boolean;
    gender?: Array<Gender>;
    membership_package_id?: Array<string>;
    is_archived?: boolean;
    age_lt?: number;
    age_gt?: number;
    age_lte?: number;
    age_gte?: number;
    date_of_birth_lt?: Date;
    date_of_birth_gt?: Date;
    date_of_birth_lte?: Date;
    date_of_birth_gte?: Date;
    birthday_lt?: Date;
    birthday_gt?: Date;
    birthday_lte?: Date;
    birthday_gte?: Date;
    feedback_rating?: Array<FeedbackRating>;
    num_registrations_lt?: number;
    num_registrations_gt?: number;
    num_registrations_lte?: number;
    num_registrations_gte?: number;
    first_attended_lt?: Date;
    first_attended_gt?: Date;
    first_attended_lte?: Date;
    first_attended_gte?: Date;
    last_attended_lt?: Date;
    last_attended_gt?: Date;
    last_attended_lte?: Date;
    last_attended_gte?: Date;
    last_registered_lt?: Date;
    last_registered_gt?: Date;
    last_registered_lte?: Date;
    last_registered_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface RequestReportXlsxContactReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    is_subscribed?: boolean;
    has_account?: boolean;
    is_archived?: boolean;
}

export interface RequestReportXlsxEventRegistrationReportRequest {
    event_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportXlsxMembershipReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
}

export interface RequestReportXlsxPaymentsReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportXlsxPayoutReconciliationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

export interface RequestReportXlsxRegistrationReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    registration_status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    include_fee?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    event_type?: Array<ProgramEventType>;
}

export interface RequestReportXlsxRegistrationReportV2Request {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    event_id?: Array<string>;
    status?: Array<RegistrationStatus>;
    attendee_gender?: Array<Gender>;
    is_fee_included?: boolean;
    feedback_rating?: Array<FeedbackRating>;
    order?: GetManyOrder;
    sort?: string;
}

export interface RequestReportXlsxSalesFinanceReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    products?: Array<string>;
    item_type?: Array<OrderItemType>;
}

export interface RequestReportXlsxSalesFinanceReportV2Request {
    program_id: string;
    sort?: string;
    order?: GetManyOrder;
    skip?: number;
    limit?: number;
    currency?: CurrencyCode;
    product_id?: Array<string>;
    product_category_id?: Array<string>;
    program_id2?: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportXlsxSalesSummaryReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
}

export interface RequestReportXlsxTaxesReportRequest {
    program_id: string;
    date_macro?: DateMacro;
    start_date?: Date;
    end_date?: Date;
    timezone?: string;
    columns?: Array<string>;
    recipient_email?: string;
    sort?: string;
    order?: GetManyOrder;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Find results for attendee report
     */
    async findReportAttendeeReportRaw(requestParameters: FindReportAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AttendeeReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportAttendeeReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/attendees`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttendeeReportFromJSON(jsonValue));
    }

    /**
     * Find results for attendee report
     */
    async findReportAttendeeReport(requestParameters: FindReportAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AttendeeReport> {
        const response = await this.findReportAttendeeReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for contact report
     */
    async findReportContactReportRaw(requestParameters: FindReportContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ContactReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportContactReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.is_subscribed !== undefined) {
            queryParameters['is_subscribed'] = requestParameters.is_subscribed;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/contacts`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactReportFromJSON(jsonValue));
    }

    /**
     * Find results for contact report
     */
    async findReportContactReport(requestParameters: FindReportContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ContactReport> {
        const response = await this.findReportContactReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for attendee report
     */
    async findReportCsvAttendeeReportRaw(requestParameters: FindReportCsvAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvAttendeeReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/attendees.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for attendee report
     */
    async findReportCsvAttendeeReport(requestParameters: FindReportCsvAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvAttendeeReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for contact report
     */
    async findReportCsvContactReportRaw(requestParameters: FindReportCsvContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvContactReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.is_subscribed !== undefined) {
            queryParameters['is_subscribed'] = requestParameters.is_subscribed;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/contacts.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for contact report
     */
    async findReportCsvContactReport(requestParameters: FindReportCsvContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvContactReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for event registration report
     */
    async findReportCsvEventRegistrationReportRaw(requestParameters: FindReportCsvEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findReportCsvEventRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/events/{event_id}/registrations.csv`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for event registration report
     */
    async findReportCsvEventRegistrationReport(requestParameters: FindReportCsvEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvEventRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for membership report
     */
    async findReportCsvMembershipReportRaw(requestParameters: FindReportCsvMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvMembershipReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/memberships.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for membership report
     */
    async findReportCsvMembershipReport(requestParameters: FindReportCsvMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvMembershipReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for payments report
     */
    async findReportCsvPaymentsReportRaw(requestParameters: FindReportCsvPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvPaymentsReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/payments.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for payments report
     */
    async findReportCsvPaymentsReport(requestParameters: FindReportCsvPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvPaymentsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for taxes report
     */
    async findReportCsvPayoutReconciliationReportRaw(requestParameters: FindReportCsvPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvPayoutReconciliationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/payout_reconciliation.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for taxes report
     */
    async findReportCsvPayoutReconciliationReport(requestParameters: FindReportCsvPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvPayoutReconciliationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find csv file for registration report
     */
    async findReportCsvRegistrationReportRaw(requestParameters: FindReportCsvRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.registration_status) {
            queryParameters['registration_status'] = requestParameters.registration_status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.include_fee !== undefined) {
            queryParameters['include_fee'] = requestParameters.include_fee;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.event_type) {
            queryParameters['event_type'] = requestParameters.event_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/registrations.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * @deprecated Find csv file for registration report
     */
    async findReportCsvRegistrationReport(requestParameters: FindReportCsvRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for registration report
     */
    async findReportCsvRegistrationReportV2Raw(requestParameters: FindReportCsvRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvRegistrationReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.event_id) {
            queryParameters['event_id'] = requestParameters.event_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.is_fee_included !== undefined) {
            queryParameters['is_fee_included'] = requestParameters.is_fee_included;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/registrations.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for registration report
     */
    async findReportCsvRegistrationReportV2(requestParameters: FindReportCsvRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvRegistrationReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find csv file for sales finance report
     */
    async findReportCsvSalesFinanceReportRaw(requestParameters: FindReportCsvSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvSalesFinanceReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.item_type) {
            queryParameters['item_type'] = requestParameters.item_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/sales_finance.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * @deprecated Find csv file for sales finance report
     */
    async findReportCsvSalesFinanceReport(requestParameters: FindReportCsvSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvSalesFinanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for sales finance report
     */
    async findReportCsvSalesFinanceReportV2Raw(requestParameters: FindReportCsvSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvSalesFinanceReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.product_category_id) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.program_id2 !== undefined) {
            queryParameters['program_id'] = requestParameters.program_id2;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/sales_finance.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for sales finance report
     */
    async findReportCsvSalesFinanceReportV2(requestParameters: FindReportCsvSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvSalesFinanceReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for sales summary report
     */
    async findReportCsvSalesSummaryReportRaw(requestParameters: FindReportCsvSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvSalesSummaryReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/sales_summary.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for sales summary report
     */
    async findReportCsvSalesSummaryReport(requestParameters: FindReportCsvSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvSalesSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find csv file for taxes report
     */
    async findReportCsvTaxesReportRaw(requestParameters: FindReportCsvTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportCsvTaxesReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/taxes.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find csv file for taxes report
     */
    async findReportCsvTaxesReport(requestParameters: FindReportCsvTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportCsvTaxesReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for event registration report
     */
    async findReportEventRegistrationReportRaw(requestParameters: FindReportEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<EventRegistrationReport>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findReportEventRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/events/{event_id}/registrations`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventRegistrationReportFromJSON(jsonValue));
    }

    /**
     * Find results for event registration report
     */
    async findReportEventRegistrationReport(requestParameters: FindReportEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<EventRegistrationReport> {
        const response = await this.findReportEventRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for membership report
     */
    async findReportMembershipReportRaw(requestParameters: FindReportMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportMembershipReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/memberships`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipReportFromJSON(jsonValue));
    }

    /**
     * Find results for membership report
     */
    async findReportMembershipReport(requestParameters: FindReportMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipReport> {
        const response = await this.findReportMembershipReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for payments report
     */
    async findReportPaymentsReportRaw(requestParameters: FindReportPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PaymentsReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportPaymentsReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/payments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentsReportFromJSON(jsonValue));
    }

    /**
     * Find results for payments report
     */
    async findReportPaymentsReport(requestParameters: FindReportPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PaymentsReport> {
        const response = await this.findReportPaymentsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for taxes report
     */
    async findReportPayoutReconciliationReportRaw(requestParameters: FindReportPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PayoutReconciliationReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportPayoutReconciliationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/payout_reconciliation`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayoutReconciliationReportFromJSON(jsonValue));
    }

    /**
     * Find results for taxes report
     */
    async findReportPayoutReconciliationReport(requestParameters: FindReportPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PayoutReconciliationReport> {
        const response = await this.findReportPayoutReconciliationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find results for registration report
     */
    async findReportRegistrationReportRaw(requestParameters: FindReportRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RegistrationReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.registration_status) {
            queryParameters['registration_status'] = requestParameters.registration_status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.include_fee !== undefined) {
            queryParameters['include_fee'] = requestParameters.include_fee;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.event_type) {
            queryParameters['event_type'] = requestParameters.event_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/registrations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationReportFromJSON(jsonValue));
    }

    /**
     * @deprecated Find results for registration report
     */
    async findReportRegistrationReport(requestParameters: FindReportRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RegistrationReport> {
        const response = await this.findReportRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for registration report
     */
    async findReportRegistrationReportV2Raw(requestParameters: FindReportRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RegistrationReportV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportRegistrationReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.event_id) {
            queryParameters['event_id'] = requestParameters.event_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.is_fee_included !== undefined) {
            queryParameters['is_fee_included'] = requestParameters.is_fee_included;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/registrations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationReportV2FromJSON(jsonValue));
    }

    /**
     * Find results for registration report
     */
    async findReportRegistrationReportV2(requestParameters: FindReportRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RegistrationReportV2> {
        const response = await this.findReportRegistrationReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find results for sales finance report
     */
    async findReportSalesFinanceReportRaw(requestParameters: FindReportSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SalesFinanceReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportSalesFinanceReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.item_type) {
            queryParameters['item_type'] = requestParameters.item_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/sales_finance`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesFinanceReportFromJSON(jsonValue));
    }

    /**
     * @deprecated Find results for sales finance report
     */
    async findReportSalesFinanceReport(requestParameters: FindReportSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SalesFinanceReport> {
        const response = await this.findReportSalesFinanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for sales finance report
     */
    async findReportSalesFinanceReportV2Raw(requestParameters: FindReportSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SalesFinanceReportV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportSalesFinanceReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.product_category_id) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.program_id2 !== undefined) {
            queryParameters['program_id'] = requestParameters.program_id2;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/sales_finance`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesFinanceReportV2FromJSON(jsonValue));
    }

    /**
     * Find results for sales finance report
     */
    async findReportSalesFinanceReportV2(requestParameters: FindReportSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SalesFinanceReportV2> {
        const response = await this.findReportSalesFinanceReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for sales summary report
     */
    async findReportSalesSummaryReportRaw(requestParameters: FindReportSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SalesSummaryReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportSalesSummaryReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/sales_summary`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SalesSummaryReportFromJSON(jsonValue));
    }

    /**
     * Find results for sales summary report
     */
    async findReportSalesSummaryReport(requestParameters: FindReportSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SalesSummaryReport> {
        const response = await this.findReportSalesSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find results for taxes report
     */
    async findReportTaxesReportRaw(requestParameters: FindReportTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<TaxesReport>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportTaxesReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/taxes`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaxesReportFromJSON(jsonValue));
    }

    /**
     * Find results for taxes report
     */
    async findReportTaxesReport(requestParameters: FindReportTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<TaxesReport> {
        const response = await this.findReportTaxesReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for attendee report
     */
    async findReportXlsxAttendeeReportRaw(requestParameters: FindReportXlsxAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxAttendeeReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/attendees.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for attendee report
     */
    async findReportXlsxAttendeeReport(requestParameters: FindReportXlsxAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxAttendeeReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for contact report
     */
    async findReportXlsxContactReportRaw(requestParameters: FindReportXlsxContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxContactReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.is_subscribed !== undefined) {
            queryParameters['is_subscribed'] = requestParameters.is_subscribed;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/contacts.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for contact report
     */
    async findReportXlsxContactReport(requestParameters: FindReportXlsxContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxContactReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for event registration report
     */
    async findReportXlsxEventRegistrationReportRaw(requestParameters: FindReportXlsxEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling findReportXlsxEventRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/events/{event_id}/registrations.xlsx`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for event registration report
     */
    async findReportXlsxEventRegistrationReport(requestParameters: FindReportXlsxEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxEventRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for membership report
     */
    async findReportXlsxMembershipReportRaw(requestParameters: FindReportXlsxMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxMembershipReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/memberships.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for membership report
     */
    async findReportXlsxMembershipReport(requestParameters: FindReportXlsxMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxMembershipReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for payments report
     */
    async findReportXlsxPaymentsReportRaw(requestParameters: FindReportXlsxPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxPaymentsReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/payments.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for payments report
     */
    async findReportXlsxPaymentsReport(requestParameters: FindReportXlsxPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxPaymentsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for taxes report
     */
    async findReportXlsxPayoutReconciliationReportRaw(requestParameters: FindReportXlsxPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxPayoutReconciliationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/payout_reconciliation.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for taxes report
     */
    async findReportXlsxPayoutReconciliationReport(requestParameters: FindReportXlsxPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxPayoutReconciliationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find xlsx file for registration report
     */
    async findReportXlsxRegistrationReportRaw(requestParameters: FindReportXlsxRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.registration_status) {
            queryParameters['registration_status'] = requestParameters.registration_status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.include_fee !== undefined) {
            queryParameters['include_fee'] = requestParameters.include_fee;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.event_type) {
            queryParameters['event_type'] = requestParameters.event_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/registrations.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * @deprecated Find xlsx file for registration report
     */
    async findReportXlsxRegistrationReport(requestParameters: FindReportXlsxRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for registration report
     */
    async findReportXlsxRegistrationReportV2Raw(requestParameters: FindReportXlsxRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxRegistrationReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.event_id) {
            queryParameters['event_id'] = requestParameters.event_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.is_fee_included !== undefined) {
            queryParameters['is_fee_included'] = requestParameters.is_fee_included;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/registrations.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for registration report
     */
    async findReportXlsxRegistrationReportV2(requestParameters: FindReportXlsxRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxRegistrationReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Find xlsx file for sales finance report
     */
    async findReportXlsxSalesFinanceReportRaw(requestParameters: FindReportXlsxSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxSalesFinanceReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.item_type) {
            queryParameters['item_type'] = requestParameters.item_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/sales_finance.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * @deprecated Find xlsx file for sales finance report
     */
    async findReportXlsxSalesFinanceReport(requestParameters: FindReportXlsxSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxSalesFinanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for sales finance report
     */
    async findReportXlsxSalesFinanceReportV2Raw(requestParameters: FindReportXlsxSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxSalesFinanceReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.product_category_id) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.program_id2 !== undefined) {
            queryParameters['program_id'] = requestParameters.program_id2;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/sales_finance.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for sales finance report
     */
    async findReportXlsxSalesFinanceReportV2(requestParameters: FindReportXlsxSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxSalesFinanceReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for sales summary report
     */
    async findReportXlsxSalesSummaryReportRaw(requestParameters: FindReportXlsxSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxSalesSummaryReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/sales_summary.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for sales summary report
     */
    async findReportXlsxSalesSummaryReport(requestParameters: FindReportXlsxSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxSalesSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find xlsx file for taxes report
     */
    async findReportXlsxTaxesReportRaw(requestParameters: FindReportXlsxTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findReportXlsxTaxesReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/taxes.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Find xlsx file for taxes report
     */
    async findReportXlsxTaxesReport(requestParameters: FindReportXlsxTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Blob> {
        const response = await this.findReportXlsxTaxesReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request attendee report csv file to be emailed
     */
    async requestReportCsvAttendeeReportRaw(requestParameters: RequestReportCsvAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvAttendeeReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/attendees.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request attendee report csv file to be emailed
     */
    async requestReportCsvAttendeeReport(requestParameters: RequestReportCsvAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvAttendeeReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request contact report csv file to be emailed
     */
    async requestReportCsvContactReportRaw(requestParameters: RequestReportCsvContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvContactReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.is_subscribed !== undefined) {
            queryParameters['is_subscribed'] = requestParameters.is_subscribed;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/contacts.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request contact report csv file to be emailed
     */
    async requestReportCsvContactReport(requestParameters: RequestReportCsvContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvContactReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request event registration csv file to be emailed
     */
    async requestReportCsvEventRegistrationReportRaw(requestParameters: RequestReportCsvEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling requestReportCsvEventRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/events/{event_id}/email/registrations.csv`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request event registration csv file to be emailed
     */
    async requestReportCsvEventRegistrationReport(requestParameters: RequestReportCsvEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvEventRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request membership report csv file to be emailed
     */
    async requestReportCsvMembershipReportRaw(requestParameters: RequestReportCsvMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvMembershipReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/memberships.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request membership report csv file to be emailed
     */
    async requestReportCsvMembershipReport(requestParameters: RequestReportCsvMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvMembershipReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request payments report csv file to be emailed
     */
    async requestReportCsvPaymentsReportRaw(requestParameters: RequestReportCsvPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvPaymentsReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/payments.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request payments report csv file to be emailed
     */
    async requestReportCsvPaymentsReport(requestParameters: RequestReportCsvPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvPaymentsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request payout reconciliation report csv file to be emailed
     */
    async requestReportCsvPayoutReconciliationReportRaw(requestParameters: RequestReportCsvPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvPayoutReconciliationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/payout_reconciliation.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request payout reconciliation report csv file to be emailed
     */
    async requestReportCsvPayoutReconciliationReport(requestParameters: RequestReportCsvPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvPayoutReconciliationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Request registration report csv file to be emailed
     */
    async requestReportCsvRegistrationReportRaw(requestParameters: RequestReportCsvRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.registration_status) {
            queryParameters['registration_status'] = requestParameters.registration_status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.include_fee !== undefined) {
            queryParameters['include_fee'] = requestParameters.include_fee;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.event_type) {
            queryParameters['event_type'] = requestParameters.event_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/registrations.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Request registration report csv file to be emailed
     */
    async requestReportCsvRegistrationReport(requestParameters: RequestReportCsvRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request registration report csv file to be emailed
     */
    async requestReportCsvRegistrationReportV2Raw(requestParameters: RequestReportCsvRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvRegistrationReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.event_id) {
            queryParameters['event_id'] = requestParameters.event_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.is_fee_included !== undefined) {
            queryParameters['is_fee_included'] = requestParameters.is_fee_included;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/email/registrations.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request registration report csv file to be emailed
     */
    async requestReportCsvRegistrationReportV2(requestParameters: RequestReportCsvRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvRegistrationReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Request sales finance report csv file to be emailed
     */
    async requestReportCsvSalesFinanceReportRaw(requestParameters: RequestReportCsvSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvSalesFinanceReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.item_type) {
            queryParameters['item_type'] = requestParameters.item_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/sales_finance.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Request sales finance report csv file to be emailed
     */
    async requestReportCsvSalesFinanceReport(requestParameters: RequestReportCsvSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvSalesFinanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request sales finance report csv file to be emailed
     */
    async requestReportCsvSalesFinanceReportV2Raw(requestParameters: RequestReportCsvSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvSalesFinanceReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.product_category_id) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.program_id2 !== undefined) {
            queryParameters['program_id'] = requestParameters.program_id2;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/email/sales_finance.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request sales finance report csv file to be emailed
     */
    async requestReportCsvSalesFinanceReportV2(requestParameters: RequestReportCsvSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvSalesFinanceReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request sales summary report csv file to be emailed
     */
    async requestReportCsvSalesSummaryReportRaw(requestParameters: RequestReportCsvSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvSalesSummaryReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/sales_summary.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request sales summary report csv file to be emailed
     */
    async requestReportCsvSalesSummaryReport(requestParameters: RequestReportCsvSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvSalesSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request taxes report csv file to be emailed
     */
    async requestReportCsvTaxesReportRaw(requestParameters: RequestReportCsvTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportCsvTaxesReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/taxes.csv`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request taxes report csv file to be emailed
     */
    async requestReportCsvTaxesReport(requestParameters: RequestReportCsvTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportCsvTaxesReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request attendee report xlsx file to be emailed
     */
    async requestReportXlsxAttendeeReportRaw(requestParameters: RequestReportXlsxAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxAttendeeReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.age !== undefined) {
            queryParameters['age'] = requestParameters.age;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.gender) {
            queryParameters['gender'] = requestParameters.gender;
        }

        if (requestParameters.membership_package_id) {
            queryParameters['membership_package_id'] = requestParameters.membership_package_id;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        if (requestParameters.age_lt !== undefined) {
            queryParameters['age_lt'] = requestParameters.age_lt;
        }

        if (requestParameters.age_gt !== undefined) {
            queryParameters['age_gt'] = requestParameters.age_gt;
        }

        if (requestParameters.age_lte !== undefined) {
            queryParameters['age_lte'] = requestParameters.age_lte;
        }

        if (requestParameters.age_gte !== undefined) {
            queryParameters['age_gte'] = requestParameters.age_gte;
        }

        if (requestParameters.date_of_birth_lt !== undefined) {
            queryParameters['date_of_birth_lt'] = (requestParameters.date_of_birth_lt as any).toISOString();
        }

        if (requestParameters.date_of_birth_gt !== undefined) {
            queryParameters['date_of_birth_gt'] = (requestParameters.date_of_birth_gt as any).toISOString();
        }

        if (requestParameters.date_of_birth_lte !== undefined) {
            queryParameters['date_of_birth_lte'] = (requestParameters.date_of_birth_lte as any).toISOString();
        }

        if (requestParameters.date_of_birth_gte !== undefined) {
            queryParameters['date_of_birth_gte'] = (requestParameters.date_of_birth_gte as any).toISOString();
        }

        if (requestParameters.birthday_lt !== undefined) {
            queryParameters['birthday_lt'] = (requestParameters.birthday_lt as any).toISOString();
        }

        if (requestParameters.birthday_gt !== undefined) {
            queryParameters['birthday_gt'] = (requestParameters.birthday_gt as any).toISOString();
        }

        if (requestParameters.birthday_lte !== undefined) {
            queryParameters['birthday_lte'] = (requestParameters.birthday_lte as any).toISOString();
        }

        if (requestParameters.birthday_gte !== undefined) {
            queryParameters['birthday_gte'] = (requestParameters.birthday_gte as any).toISOString();
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.num_registrations_lt !== undefined) {
            queryParameters['num_registrations_lt'] = requestParameters.num_registrations_lt;
        }

        if (requestParameters.num_registrations_gt !== undefined) {
            queryParameters['num_registrations_gt'] = requestParameters.num_registrations_gt;
        }

        if (requestParameters.num_registrations_lte !== undefined) {
            queryParameters['num_registrations_lte'] = requestParameters.num_registrations_lte;
        }

        if (requestParameters.num_registrations_gte !== undefined) {
            queryParameters['num_registrations_gte'] = requestParameters.num_registrations_gte;
        }

        if (requestParameters.first_attended_lt !== undefined) {
            queryParameters['first_attended_lt'] = (requestParameters.first_attended_lt as any).toISOString();
        }

        if (requestParameters.first_attended_gt !== undefined) {
            queryParameters['first_attended_gt'] = (requestParameters.first_attended_gt as any).toISOString();
        }

        if (requestParameters.first_attended_lte !== undefined) {
            queryParameters['first_attended_lte'] = (requestParameters.first_attended_lte as any).toISOString();
        }

        if (requestParameters.first_attended_gte !== undefined) {
            queryParameters['first_attended_gte'] = (requestParameters.first_attended_gte as any).toISOString();
        }

        if (requestParameters.last_attended_lt !== undefined) {
            queryParameters['last_attended_lt'] = (requestParameters.last_attended_lt as any).toISOString();
        }

        if (requestParameters.last_attended_gt !== undefined) {
            queryParameters['last_attended_gt'] = (requestParameters.last_attended_gt as any).toISOString();
        }

        if (requestParameters.last_attended_lte !== undefined) {
            queryParameters['last_attended_lte'] = (requestParameters.last_attended_lte as any).toISOString();
        }

        if (requestParameters.last_attended_gte !== undefined) {
            queryParameters['last_attended_gte'] = (requestParameters.last_attended_gte as any).toISOString();
        }

        if (requestParameters.last_registered_lt !== undefined) {
            queryParameters['last_registered_lt'] = (requestParameters.last_registered_lt as any).toISOString();
        }

        if (requestParameters.last_registered_gt !== undefined) {
            queryParameters['last_registered_gt'] = (requestParameters.last_registered_gt as any).toISOString();
        }

        if (requestParameters.last_registered_lte !== undefined) {
            queryParameters['last_registered_lte'] = (requestParameters.last_registered_lte as any).toISOString();
        }

        if (requestParameters.last_registered_gte !== undefined) {
            queryParameters['last_registered_gte'] = (requestParameters.last_registered_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/attendees.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request attendee report xlsx file to be emailed
     */
    async requestReportXlsxAttendeeReport(requestParameters: RequestReportXlsxAttendeeReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxAttendeeReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request contact report xlsx file to be emailed
     */
    async requestReportXlsxContactReportRaw(requestParameters: RequestReportXlsxContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxContactReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.is_subscribed !== undefined) {
            queryParameters['is_subscribed'] = requestParameters.is_subscribed;
        }

        if (requestParameters.has_account !== undefined) {
            queryParameters['has_account'] = requestParameters.has_account;
        }

        if (requestParameters.is_archived !== undefined) {
            queryParameters['is_archived'] = requestParameters.is_archived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/contacts.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request contact report xlsx file to be emailed
     */
    async requestReportXlsxContactReport(requestParameters: RequestReportXlsxContactReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxContactReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request event registration xlsx file to be emailed
     */
    async requestReportXlsxEventRegistrationReportRaw(requestParameters: RequestReportXlsxEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.event_id === null || requestParameters.event_id === undefined) {
            throw new runtime.RequiredError('event_id','Required parameter requestParameters.event_id was null or undefined when calling requestReportXlsxEventRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/events/{event_id}/email/registrations.xlsx`.replace(`{${"event_id"}}`, encodeURIComponent(String(requestParameters.event_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request event registration xlsx file to be emailed
     */
    async requestReportXlsxEventRegistrationReport(requestParameters: RequestReportXlsxEventRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxEventRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request membership report xlsx file to be emailed
     */
    async requestReportXlsxMembershipReportRaw(requestParameters: RequestReportXlsxMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxMembershipReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/memberships.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request membership report xlsx file to be emailed
     */
    async requestReportXlsxMembershipReport(requestParameters: RequestReportXlsxMembershipReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxMembershipReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * FRequest payments report xlsx file to be emailed
     */
    async requestReportXlsxPaymentsReportRaw(requestParameters: RequestReportXlsxPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxPaymentsReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/payments.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * FRequest payments report xlsx file to be emailed
     */
    async requestReportXlsxPaymentsReport(requestParameters: RequestReportXlsxPaymentsReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxPaymentsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request payout reconciliation report xlsx file to be emailed
     */
    async requestReportXlsxPayoutReconciliationReportRaw(requestParameters: RequestReportXlsxPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxPayoutReconciliationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/payout_reconciliation.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request payout reconciliation report xlsx file to be emailed
     */
    async requestReportXlsxPayoutReconciliationReport(requestParameters: RequestReportXlsxPayoutReconciliationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxPayoutReconciliationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Request registration report xlsx file to be emailed
     */
    async requestReportXlsxRegistrationReportRaw(requestParameters: RequestReportXlsxRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxRegistrationReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.registration_status) {
            queryParameters['registration_status'] = requestParameters.registration_status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.include_fee !== undefined) {
            queryParameters['include_fee'] = requestParameters.include_fee;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.event_type) {
            queryParameters['event_type'] = requestParameters.event_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/registrations.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Request registration report xlsx file to be emailed
     */
    async requestReportXlsxRegistrationReport(requestParameters: RequestReportXlsxRegistrationReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxRegistrationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request registration report xlsx file to be emailed
     */
    async requestReportXlsxRegistrationReportV2Raw(requestParameters: RequestReportXlsxRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxRegistrationReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.event_id) {
            queryParameters['event_id'] = requestParameters.event_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.is_fee_included !== undefined) {
            queryParameters['is_fee_included'] = requestParameters.is_fee_included;
        }

        if (requestParameters.feedback_rating) {
            queryParameters['feedback_rating'] = requestParameters.feedback_rating;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/email/registrations.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request registration report xlsx file to be emailed
     */
    async requestReportXlsxRegistrationReportV2(requestParameters: RequestReportXlsxRegistrationReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxRegistrationReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Request sales finance report xlsx file to be emailed
     */
    async requestReportXlsxSalesFinanceReportRaw(requestParameters: RequestReportXlsxSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxSalesFinanceReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.products) {
            queryParameters['products'] = requestParameters.products;
        }

        if (requestParameters.item_type) {
            queryParameters['item_type'] = requestParameters.item_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/sales_finance.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * @deprecated Request sales finance report xlsx file to be emailed
     */
    async requestReportXlsxSalesFinanceReport(requestParameters: RequestReportXlsxSalesFinanceReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxSalesFinanceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request sales finance report xlsx file to be emailed
     */
    async requestReportXlsxSalesFinanceReportV2Raw(requestParameters: RequestReportXlsxSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxSalesFinanceReportV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        if (requestParameters.product_id) {
            queryParameters['product_id'] = requestParameters.product_id;
        }

        if (requestParameters.product_category_id) {
            queryParameters['product_category_id'] = requestParameters.product_category_id;
        }

        if (requestParameters.program_id2 !== undefined) {
            queryParameters['program_id'] = requestParameters.program_id2;
        }

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/reports/programs/{program_id}/email/sales_finance.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request sales finance report xlsx file to be emailed
     */
    async requestReportXlsxSalesFinanceReportV2(requestParameters: RequestReportXlsxSalesFinanceReportV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxSalesFinanceReportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request sales summary report xlsx file to be emailed
     */
    async requestReportXlsxSalesSummaryReportRaw(requestParameters: RequestReportXlsxSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxSalesSummaryReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/sales_summary.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request sales summary report xlsx file to be emailed
     */
    async requestReportXlsxSalesSummaryReport(requestParameters: RequestReportXlsxSalesSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxSalesSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request taxes report xlsx file to be emailed
     */
    async requestReportXlsxTaxesReportRaw(requestParameters: RequestReportXlsxTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestReportXlsxTaxesReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.date_macro !== undefined) {
            queryParameters['date_macro'] = requestParameters.date_macro;
        }

        if (requestParameters.start_date !== undefined) {
            queryParameters['start_date'] = (requestParameters.start_date as any).toISOString();
        }

        if (requestParameters.end_date !== undefined) {
            queryParameters['end_date'] = (requestParameters.end_date as any).toISOString();
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.columns) {
            queryParameters['columns'] = requestParameters.columns;
        }

        if (requestParameters.recipient_email !== undefined) {
            queryParameters['recipient_email'] = requestParameters.recipient_email;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/reports/programs/{program_id}/email/taxes.xlsx`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Request taxes report xlsx file to be emailed
     */
    async requestReportXlsxTaxesReport(requestParameters: RequestReportXlsxTaxesReportRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.requestReportXlsxTaxesReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
